import data from "../../../../../src/Textarea/Textarea.docs.json";
import { Textarea } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Textarea,
  React
};